import { Routes, Route, Navigate } from 'react-router-dom'
import { MainLayout } from '@/components/layout'
import { Toaster } from '@/components/ui/toaster'
import { GlobalAlertsWatcher } from '@/components/GlobalAlertsWatcher'
import Dashboard from '@/pages/Dashboard'
import Alerts from '@/pages/Alerts'
import AlertReviews from '@/pages/AlertReviews'
import Orderbook from '@/pages/Orderbook'
import OrderbookOverview from '@/pages/OrderbookOverview'
import MarkPrice from '@/pages/MarkPrice'
import Funding from '@/pages/Funding'
import PriceDiff from '@/pages/PriceDiff'
import Splash from '@/pages/Splash'
import Spread from '@/pages/Spread'
import Tags from '@/pages/Tags'
import Aliases from '@/pages/Aliases'
import Settings from '@/pages/Settings'
import Account from '@/pages/Account'
import Login from '@/pages/Login'
import CoinOverview from '@/pages/CoinOverview'
import Screener from '@/pages/Screener'
import OrderbooksScreener from '@/pages/OrderbooksScreener'
import AdminDebug from '@/pages/AdminDebug'
import DbBrowser from '@/pages/DbBrowser'
import Positions from '@/pages/Positions'
import { FEATURE_SCREENER_ENABLED } from '@/lib/featureFlags'

function App() {
    return (
        <>
            <Routes>
                {/* Login page - outside main layout */}
                <Route path="/login" element={<Login />} />

                {/* Main app routes */}
                <Route element={<MainLayout />}>
                    <Route path="/" element={<Dashboard />} />
                    <Route path="/market-hours" element={<Navigate to="/" replace />} />
                    {FEATURE_SCREENER_ENABLED && <Route path="/screener" element={<Screener />} />}
                    {FEATURE_SCREENER_ENABLED && <Route path="/orderbooks-screener" element={<OrderbooksScreener />} />}
                    <Route path="/coin-overview" element={<CoinOverview />} />
                    <Route path="/orderbook-overview" element={<OrderbookOverview />} />
                    <Route path="/positions" element={<Positions />} />
                    <Route path="/alerts" element={<Alerts />} />
                    <Route path="/alert-reviews" element={<AlertReviews />} />
                    <Route path="/orderbook" element={<Orderbook />} />
                    <Route path="/mark-price" element={<MarkPrice />} />
                    <Route path="/funding" element={<Funding />} />
                    <Route path="/price-diff" element={<PriceDiff />} />
                    <Route path="/splash" element={<Splash />} />
                    <Route path="/spread" element={<Spread />} />
                    <Route path="/tags" element={<Tags />} />
                    <Route path="/aliases" element={<Aliases />} />
                    <Route path="/settings" element={<Settings />} />
                    <Route path="/account" element={<Account />} />
                    <Route path="/admin-debug" element={<AdminDebug />} />
                    <Route path="/db-browser" element={<DbBrowser />} />
                </Route>
            </Routes>
            <GlobalAlertsWatcher />
            <Toaster />
        </>
    )
}

export default App
